import { z } from "zod";

import { GetOrdersStatus } from "@/api/schemas/getOrdersStatus";

const orderStatusValues = Object.values(GetOrdersStatus) as [
  (typeof GetOrdersStatus)[keyof typeof GetOrdersStatus],
  ...(typeof GetOrdersStatus)[keyof typeof GetOrdersStatus][],
];

export const orderStatusSchema = z.enum(orderStatusValues);

const coercedNumber = z
  .union([z.number(), z.string()])
  .transform((value) => {
    const parsed = typeof value === "number" ? value : Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  })
  .optional();

export const orderSchema = z.object({
  id: z.number(),
  order_number: z.union([z.string(), z.number()]).optional(),
  final_payable_amount: coercedNumber,
  total_amount: coercedNumber,
  created_at: z.string().optional(),
  createdAt: z.string().optional(),
  status: orderStatusSchema,
  customer_name: z.string().optional(),
  customer_city: z.string().optional(),
  product_name: z.string().optional(),
  customer: z
    .object({
      full_name: z.string().optional(),
      city: z.string().optional(),
    })
    .optional(),
  items: z
    .array(
      z.object({
        product_name: z.string().optional(),
      }),
    )
    .optional(),
});

export const responseMetaSchema = z.object({
  total: z.number(),
  page: z.number(),
  per_page: z.number(),
  last_page: z.number(),
});

export const orderListResponseSchema = z.object({
  message: z.string(),
  statusCode: z.number(),
  data: z.array(orderSchema),
  meta: responseMetaSchema,
});

export type DashboardOrder = z.infer<typeof orderSchema>;
export type OrderListResponse = z.infer<typeof orderListResponseSchema>;

export function parseOrderListResponse(raw: unknown): OrderListResponse | null {
  const result = orderListResponseSchema.safeParse(raw);
  return result.success ? result.data : null;
}
